import { Component } from '@angular/core';

@Component({
  selector: 'phc-balance-image-component',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.scss']
})
export class BalanceComponent  {

  

}
